import store from '@/store'

/**
 * 判断是否拥有该页面权限
 * @param {*} current  当前需要判断的权限名
 * @returns resultBool 布尔值
 */
export function hasPermission(current) {
  let buttonPermissions = store.getters && store.getters.button_permissions
  buttonPermissions = buttonPermissions['modules'] || []
  if (!(current && current instanceof Array)) {
    throw new Error('需要角色！如v-permission=“[\'admin\']”')
  }
  // 如果为空则不限制
  if (current.length === 0) {
    return true
  }
  // 循环所有拥有的权限判断当前按钮是否在里面
  const hasPermission = buttonPermissions.some(role => {
    return current.includes(role)
  })
  return hasPermission
}

/**
 * 是否为超管
 * @param userInfo
 * @returns {boolean}
 */
export function isAdmin(userInfo) {
  return (userInfo['type'] === 1) || (userInfo['super'] === 1)
}
